import React, { Component } from 'react';
import Slider from "react-slick";
import TextField from './../../component/TextField';
import Dropdown from './../../component/Dropdown';
import DropdownMaster from './../../component/DropdownMaster';
import FpgMinusIcon from './../../icons/fpgminusicon';
import FpgPlusIcon from './../../icons/fpgplusicon';
import CopyIcon from './../../icons/copyicon';
import Textarea from '../Textarea';
import PopUpCustomAll from './../../component/fpg/create/popUpCustomAll'
//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from './../../redux/bindActionCretor'
import { PAF_TYPES, isNewFrontierCategory } from './../../cosntants'

//Service import
import service from './../../services'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';
import Loader from './../../component/loader';
import UploadForm from './../../component/fpg/create/UploadForm';

import commonImage from './../../commonImage';
import ErrorPopUp from '../errorPopUp';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DraggerIcon from '../../icons/draggericon';
import CheckBox from '../CheckBox';
import ModalMessage from '../../component/ModalMessage'
import { STORAGE_PATHS } from '../../cosntants';
import ConflictSaveModal from '../../component/ConflictSaveModal';


let sub;

const mapStateToProps = state => ({
    PostAcceptanceEditListId: state.PostAcceptanceEditListId,
    countries: state.countries,
    recordConflict: state.recordConflict,
})


const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

const getEmbedUrl = (url) => {
    if (!url) return '';
    if (url.includes('youtube.com/embed/') || url.includes('player.vimeo.com/video/')) return url;
    const ytMatch = url.match(/(?:youtube\.com\/watch\?[^#]*v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
    if (ytMatch) return `https://www.youtube.com/embed/${ytMatch[1]}`;
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    return url;
};

const PRE_FIX = {
    facebook: "https://www.facebook.com/",
    bluesky: "https://bsky.app/profile/",
    instagram: "https://www.instagram.com/",
    tiktok: "https://www.tiktok.com/@",
    twitter: "https://x.com/",
    youtube: "https://www.",
}

class Projectinfo extends Component {
    constructor(props) {
        super(props)
        this.apiserve = new service();
        this.state = {
            pafProjectType: '',
            formData: '',
            errorPopup: false,
            showConflictModal: false,
            errorMsg: '',
            file: null,
            LoglineLength: 0,
            creditCounter: 0,
            bioErrors: {},
            countryType: this.props.countries,
            filmcreditLabels: [],
            newFrontierCreditLabel: [],
            pafType: [],
            filmCategoryData: [],
            loglineValidation: false,
            userInfo: {
                images: [
                    {
                        _id: Math.random().toString(),
                        link: "",
                        inSite: ""
                    },
                    {
                        _id: Math.random().toString(),
                        link: "",
                        inSite: ""
                    },
                    {
                        _id: Math.random().toString(),
                        link: "",
                        inSite: ""
                    }
                ],
                projectId: '',

                mediaId: '',
                fileMakerId: '',

                pafType: '',
                credits: [],
                countryOfOrigin: [],

                timecodeOccursInProject: '',

                category: '',
                article: '',
                title: '',
                logline: '',
                englishPhoneticProdununciation: '',
                projectInfo: {

                    premiereStatus: '',
                    yearFinished: '',
                    inPersonFormat: '',
                    onlineFormat: '',
                    aspectRatio: '',
                    soundFormat: '',
                    color: '',
                    language: '',
                    subtitles: '',
                    finalRunTime: '',
                    runTime: '',
                    includeStroboscopicImg: '',
                    aiAspect: '',
                    timecodeOccursInProject: '',
                    captionAudioInDCP: '',
                    allOfYourScreening: '',
                    repeatScreening: '',
                    premiereScreening: '',
                    requiredDCP: '',
                    requiredDCPAndProResFile: '',
                    requiredDCPAndProResFileOther: '',
                    requiredDCPOther: '',
                    premiereScreeningOther: '',
                    repeatScreeningOther: '',
                    allOfYourScreeningOther: '',
                },
                digitalMedia: {
                    officialWebsite: '',
                    youtubeOrVimeoTrailer: '',
                    instagram: '',
                    facebook: '',
                    twitter: '',
                    hastag: '',
                    bluesky: '',
                },
                publicContact: {
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    company: '',
                    publicEmail: '',
                    website: '',
                    phoneNumber: '',
                    type: '',
                },
                postFestivalContact: {
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    company: '',
                    publicEmail: '',
                    website: '',
                    phoneNumber: '',
                    type: '',
                },
                secondPostFestivalContact: {
                    firstName: '',
                    middleName: '',
                    lastName: '',
                    company: '',
                    publicEmail: '',
                    website: '',
                    phoneNumber: '',
                    type: '',
                },
                indieTopcredit: {},
                indieAdditionalTopCredit: {}
            },
            projectUserId: this.props.PostAcceptanceEditListId,
            previwId:'',
            isDraggable: false,
            messageModal: false,
            isProjectinfoEdited: false,
        }
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                urlValidation: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                websiteValid: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([a-zA-Z '. -]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                companyName: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 ' , . & !]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                }
            }
        });
        this.apiserve = new service();
    }

    markProjectinfoEdited = () => {
        if (!this.state.isProjectinfoEdited) {
            this.setState({ isProjectinfoEdited: true });
        }
    }

    updateState = (state, callback) => {
        this.setState(state, () => {
            this.markProjectinfoEdited();
            if (callback) callback();
        });
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    hex = (value) => {
        return Math.floor(value).toString(16)
    }

    generateObjectId = () => {
        return this.hex(Date.now() / 1000) +
            ' '.repeat(16).replace(/./g, () => this.hex(Math.random() * 16))
    }

    getCreditCount = () => {
        let num = 0
        this.state.userInfo.credits.forEach((item, i) => {
            if(this.state.userInfo?.pafType === PAF_TYPES.INDIE_SERIES){
                if(item.identifier !== this.state.userInfo?.indieTopcredit?.identifier && item.identifier !== this.state.userInfo?.indieAdditionalTopCredit?.identifier){
                    num = num + item.creditType.length
                }
            } else {
                if (item.identifier !== 'director' && item.identifier !== 'screenwriter' && item.identifier !== 'principalcast') {
                    num = num + item.creditType.length
                }
            }
        })
        this.setState({ creditCounter: num })
        return num
    }
    getCreditLabel = (ID) => {
        if (this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER) {
            return this.state.newFrontierCreditLabel.find(_ => _._id === ID)?.identifier
        } else {
            return this.state.filmcreditLabels.find(_ => _._id === ID)?.identifier
        }
    }

    NameComparator(a, b) {
        if(a !== undefined && b !== undefined) {
            if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
            if (a.name.toLowerCase() > b.name) return 1;
            return 0;
        }
    }

    componentWillUnmount = () => {
        if(sub) {
            sub.unsubscribe();
        }
    }

    componentDidMount = () => {

        if (this.state.projectUserId) {
            this.apiserve.sendevent("paf|project|getProjectInfo", {
                id: this.state.projectUserId
            });
            this.apiserve.sendevent("paf|project|getDetail", {})
        }

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case 'paf|project|getDetail':
                    if (!response.error) {
                        this.setState({
                            filmCategoryData: response.data.filmCategoryData,
                            pafType: response.data.pafType,
                            filmcreditLabels: response.data.filmcreditLabels.sort(this.NameComparator),
                            newFrontierCreditLabel: response.data.newFrontierCreditLabel.sort(this.NameComparator),
                            formData: response.data,
                            pafProjectType: response.data.pafProjectType,
                            NewFrontierCategoryData: response.data.NewFrontierCategoryData
                        })
                    }
                    break;
                case "paf|getLastUpdated":
                    this.setState({
                        getLastUpdated: response.data
                    })
                    break;
                case "paf|project|getProjectInfo":
                    if (!response.error) {
                        let len = (response?.data?.logline || response?.data?.synopsis || '').replace(/[\t\n\r\\]/gm, " ").split(/\s+/)
                        len = len?.filter(_ => _ !== '');

                        var ContactInfo = response.data;
                        const meetArtistIdentifier = response.data.pafType === PAF_TYPES.NEW_FRONTIER ? 'leadartist' : response.data.credits[0].identifier;
                        const credits = response.data.credits.map((credit) => {
                            if (credit.identifier === meetArtistIdentifier) {
                                credit.creditType.forEach((item) => {
                                    if (!!item?.creditDetails?.facebook) {
                                        item.creditDetails.facebook = item?.creditDetails?.facebook.replace(PRE_FIX.facebook, '');
                                    }
                                    if (!!item?.creditDetails?.bluesky) {
                                        item.creditDetails.bluesky = item?.creditDetails?.bluesky.replace(PRE_FIX.bluesky, '');
                                    }
                                    if (!!item?.creditDetails?.instagram) {
                                        item.creditDetails.instagram = item?.creditDetails?.instagram.replace(PRE_FIX.instagram, '');
                                    }
                                    if (!!item?.creditDetails?.tiktok) {
                                        item.creditDetails.tiktok = item?.creditDetails?.tiktok.replace(PRE_FIX.tiktok, '');
                                    }
                                    if (!!item?.creditDetails?.twitter) {
                                        item.creditDetails.twitter = item?.creditDetails?.twitter.replace(PRE_FIX.twitter, '');
                                    }
                                    if (!!item?.creditDetails?.youtube) {
                                        item.creditDetails.youtube = item?.creditDetails?.youtube.replace(PRE_FIX.youtube, '');
                                    }
                                })
                                return credit
                            } else {
                                return credit
                            }
                        })
                        this.setState({
                            LoglineLength: len.length,
                            userdata: ContactInfo,
                            userInfo: {
                                pafType: response.data.pafType,
                                images: response.data.images.length === 0 ? [{ _id: Math.random().toString(), link: "", inSite: "" }, { _id: Math.random().toString(), link: "", inSite: "" }, { _id: Math.random().toString(), link: "", inSite: "" }] : response.data.images,
                                projectId: response.data._id,
                                fileMakerId: response.data.fileMakerId,
                                mediaId: response.data.mediaId,
                                englishPhoneticProdununciation: response.data.englishPhoneticProdununciation,
                                credits: credits, 
                                filmProjectType: response.data.filmProjectType,
                                filmCategoryData: response.data.filmCategoryData,
                                category: response.data.category,
                                article: response.data.article,
                                title: response.data.title,
                                logline: response?.data?.logline || response?.data?.synopsis || '',
                                countryOfOrigin: response.data.countryOfOrigin.length > 0 ? response.data.countryOfOrigin : [{ id: Math.random().toString(), country: '' }],
                                projectInfo: {
                                    soundFormat: response.data.projectInfo.soundFormat,
                                    premiereStatus: response.data.projectInfo.premiereStatus,
                                    yearFinished: response.data.projectInfo.yearFinished,
                                    inPersonFormat: response.data.projectInfo.inPersonFormat,
                                    onlineFormat: response.data.projectInfo.onlineFormat,
                                    aspectRatio: response.data.projectInfo.aspectRatio,
                                    color: response.data.projectInfo.color,
                                    language: response.data.projectInfo.language,
                                    subtitles: response.data.projectInfo.subtitles,
                                    finalRunTime: response.data.projectInfo.finalRunTime,
                                    runTime: response.data.projectInfo.runTime,
                                    includeStroboscopicImg: response.data.projectInfo.includeStroboscopicImg,
                                    aiAspect: response.data.projectInfo.aiAspect,
                                    aiAspectOther: response.data.projectInfo.aiAspectOther,
                                    timecodeOccursInProject: response.data.projectInfo.timecodeOccursInProject,
                                    captionAudioInDCP: response.data.projectInfo.captionAudioInDCP,
                                    allOfYourScreening: response.data.projectInfo.allOfYourScreening,
                                    repeatScreening: response.data.projectInfo.repeatScreening,
                                    premiereScreening: response.data.projectInfo.premiereScreening,
                                    requiredDCP: response.data.projectInfo.requiredDCP,
                                    requiredDCPAndProResFile: response.data.projectInfo.requiredDCPAndProResFile,
                                    requiredDCPAndProResFileOther: response.data.projectInfo.requiredDCPAndProResFileOther,
                                    requiredDCPOther: response.data.projectInfo.requiredDCPOther,
                                    premiereScreeningOther: response.data.projectInfo.premiereScreeningOther,
                                    repeatScreeningOther: response.data.projectInfo.repeatScreeningOther,
                                    allOfYourScreeningOther: response.data.projectInfo.allOfYourScreeningOther,
                                },
                                digitalMedia: {
                                    officialWebsite: response.data.digitalMedia.officialWebsite.replace('https://www.',''),
                                    youtubeOrVimeoTrailer: response.data.digitalMedia.youtubeOrVimeoTrailer.replace('https://www.',''),
                                    instagram: response.data.digitalMedia.instagram.replace('https://www.instagram.com/',''),
                                    facebook: response.data.digitalMedia.facebook.replace('https://www.facebook.com/',''),
                                    twitter: (response.data.digitalMedia.twitter ?? '').replace('https://x.com/',''),
                                    hastag: response.data.digitalMedia.hastag,
                                    tiktok: (response.data.digitalMedia.tiktok ?? '').replace('https://www.tiktok.com/@',''),
                                    bluesky: (response.data.digitalMedia.bluesky ?? '').replace('https://bsky.app/profile/',''),
                                },
                                publicContact: {
                                    firstName: response.data.publicContact.firstName,
                                    middleName: response.data.publicContact.middleName,
                                    lastName: response.data.publicContact.lastName,
                                    company: response.data.publicContact.company,
                                    publicEmail: response.data.publicContact.publicEmail,
                                    website: response.data.publicContact.website.replace('https://www.',''),
                                    phoneNumber: response.data.publicContact.phoneNumber,
                                    type: response.data.publicContact.type,
                                },
                                postFestivalContact: {
                                    firstName: response.data.postFestivalContact.firstName,
                                    middleName: response.data.postFestivalContact.middleName,
                                    lastName: response.data.postFestivalContact.lastName,
                                    company: response.data.postFestivalContact.company,
                                    publicEmail: response.data.postFestivalContact.publicEmail,
                                    website: response.data.postFestivalContact.website.replace('https://www.',''),
                                    phoneNumber: response.data.postFestivalContact.phoneNumber,
                                    type: response.data.postFestivalContact.type,
                                },
                                secondPostFestivalContact: {
                                    firstName: response?.data?.secondPostFestivalContact?.firstName ?? "",
                                    middleName: response?.data?.secondPostFestivalContact?.middleName ?? "",
                                    lastName: response?.data?.secondPostFestivalContact?.lastName ?? "",
                                    company: response?.data?.secondPostFestivalContact?.company ?? "",
                                    publicEmail: response?.data?.secondPostFestivalContact?.publicEmail ?? "",
                                    website: (response?.data?.secondPostFestivalContact?.website ?? "").replace('https://www.',''),
                                    phoneNumber: response?.data?.secondPostFestivalContact?.phoneNumber ?? "",
                                    type: response?.data?.secondPostFestivalContact?.type ?? "",
                                },
                                // Contact info
                                mainPublicityContacts:response.data.mainPublicityContacts,
                                mainContacts:response.data.mainContacts,
                                techContact:response.data.techContact,
                                filmProjectType: response.data.filmProjectType,
                                composer:response.data.composer,
                                userId:response.data.userId,
                                distributor:response.data.distributor,
                                editor:response.data.editor,
                                salesAgent:response.data.salesAgent.length > 0 ? response.data.salesAgent : [{
                                    address1: "",
                                    address2: "",
                                    city: "",
                                    company: "",
                                    country: "",
                                    email: "",
                                    firstName: "",
                                    lastName: "",
                                    middleName: "",
                                    distributionType:"",
                                    phoneNumber: "",
                                    state: "",
                                    title: "",
                                    type: "",
                                    zipCode: "",
                                    _id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString(),
                                }],
                                cinematographer:response.data.cinematographer,
                                indieTopcredit: response.data?.indieTopcredit,
                                indieAdditionalTopCredit: response.data?.indieAdditionalTopCredit,
                                // Project Internal
                            }

                        } , () => {
                            this.setState({ isProjectinfoEdited: false });
                            this.getCreditCount()
                        })

                    }

                    break;
                case "paf|project|updateFirstPage":

                    if (!response.error) {
                        this.setState({ loaderFlag: false, btnDisabled: false, isProjectinfoEdited: false })
                        this.apiserve.success("Updated successfully.!");
                        return;
                    }
                    break;
                case "tempStorage|create":
                    if (!response.error) {
                        this.setState({
                            previwId:response?.data?._id,
                            btnDisabled: false,
                            loaderFlag: false
                        })
                        window.open(process.env.REACT_APP_FRONTEND_ORIGIN_PAF + `Preview/paf-preview?data=${response?.data?._id}`);
                    }
                    else this.apiserve.error(response.data.error)
                    break;

                default: break;

            }
        });
    }

    onInputChange = (e) => {
        if (e.target.value === "Select From Below") {
            e.target.value = "";
        }
        const { name, value } = e.target;
        if (
            name === "premiereStatus" ||
            name === "yearFinished" ||
            name === "inPersonFormat" ||
            name === "onlineFormat" ||
            name === "aspectRatio" ||
            name === "soundFormat" ||
            name === 'color' ||
            name === 'language' ||
            name === 'subtitles' ||
            name === 'finalRunTime' ||
            name === 'captionAudioInDCP' ||
            name === 'includeStroboscopicImg' ||
            name === 'aiAspect' ||
            name === 'timecodeOccursInProject' ||
            name === 'runTime'
        ) {
            this.updateState({
                userInfo: {
                    ...this.state.userInfo,
                    projectInfo: {
                        ...this.state.userInfo.projectInfo,
                        [name]: value,
                    },
                },
            });
        } else if (name === "officialWebsite" || name === "youtubeOrVimeoTrailer" || name === "instagram" || name === "facebook" || name === "twitter" || name === "hastag") {
            this.updateState({
                userInfo: {
                    ...this.state.userInfo,
                    digitalMedia: {
                        ...this.state.userInfo.digitalMedia,
                        [name]: value,
                    },
                },
            });
        } else if (
            name === "addressLine1" ||
            name === "addressLine2" ||
            name === "country" ||
            name === "city" ||
            name === "street" ||
            name === "state" ||
            name === "zip"
        ) {
            this.updateState({
                userInfo: {
                    ...this.state.userInfo,
                    mailAddress: {
                        ...this.state.userInfo.mailAddress,
                        [name]: value,
                    },
                },
            });
        } else if (
            name === "addressLine1Billing" ||
            name === "addressLine2Billing" ||
            name === "streetBilling" ||
            name === "countryBilling" ||
            name === "cityBilling" ||
            name === "stateBilling" ||
            name === "zipBilling"
        ) {
            this.updateState({
                sameAs: false,
                valueSameAs: false,
                userInfo: {
                    ...this.state.userInfo,
                    accountBillingAddress: {
                        ...this.state.userInfo.accountBillingAddress,
                        [name]: value,
                    },
                },
            }, () => { this.updateStatus(); });
        } else if (name === 'primaryInterest' || name === 'secondaryInterest') {
            this.updateState({
                userInfo: {
                    ...this.state.userInfo,
                    collab: {
                        ...this.state.userInfo.collab,
                        [name]: value
                    }
                }
            })
        }
        else {
            this.updateState({
                userInfo: {
                    ...this.state.userInfo,
                    [name]: value,
                },
                [name]: value
            });
        }
    }

    screeningChange = (e) => {
        const { name, value } = e.target
        if (name === 'logline') {
            let len = value.split(/\s+/)
            len = len.filter(_ => _ !== '');
            if (len.length <= (( this.state.userInfo.pafType === PAF_TYPES.NARRATIVE_SHORTS) ? 40:50)) {
                this.updateState({
                    ...this.state,
                    userInfo: {
                        ...this.state.userInfo,
                        [name]: value
                    },
                    LoglineLength: len.length
                })

                this.setState({ LoglineLength: len.length })
            }
        }
        else {
            const updated = { ...this.state.userInfo, [name]: value };
            if (name === 'category') {
                if (!isNewFrontierCategory(value, this.state.filmCategoryData, this.state.NewFrontierCategoryData)) {
                    updated.filmProjectType = '';
                }
            }
            this.updateState({
                ...this.state,
                userInfo: updated
            })
        }


    }

    selectCountryOfOrigin = (e, id) => {

        let countries = this.state.userInfo.countryOfOrigin
        countries.forEach(country => { if (country.id === id) country.country = e.target.value });
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,

                countryOfOrigin: {
                    ...this.state.userInfo.countryOfOrigin,
                    country: countries
                }
            }
        })
    }

    onInputChangeMeet = (e, CID, IID) => {
        const { name, value } = e.target
        if (name === 'bio') {
            const len = (value?.split(/\s+/) || []).filter(_ => _ !== '');
            const errorKey = `${CID}_${IID}`;
            let newCredit = this.state.userInfo.credits
            newCredit.forEach(credit => {
                if (credit._id === CID) {
                    credit.creditType.forEach(data => {
                        if (data._id === IID) {
                            data.creditDetails[name] = value
                        }
                    })
                }
            });
            this.updateState({
                ...this.state,
                userInfo: {
                    ...this.state.userInfo,
                    credits: newCredit
                },
                bioErrors: { ...this.state.bioErrors, [errorKey]: len.length > 50 }
            })
        } else {
            let newCredit = this.state.userInfo.credits
            newCredit.forEach(credit => {
                if (credit._id === CID) {
                    credit.creditType.forEach(data => {
                        if (data._id === IID) {
                            const { name, value } = e.target
                            if (name === 'firstName' || name === 'lastName' || name === 'middleName')
                                data[name] = value
                            else {
                                if (PRE_FIX[name]) {
                                    data.creditDetails[name] = value.replace(PRE_FIX[name], '');
                                } else {
                                    data.creditDetails[name] = value
                                }
                            }
                        }
                    })
                }
            });
            this.updateState({
                ...this.state,
                userInfo: {
                    ...this.state.userInfo,
                    credits: newCredit
                }

            })
        }
    }

    DigitalChange = (e) => {
        const prefixMap = {
            youtubeOrVimeoTrailer: "https://www.",
            facebook: "https://www.facebook.com/",
            officialWebsite: "https://www.",
            instagram: "https://www.instagram.com/",
            bluesky: "https://bsky.app/profile/",
            twitter: "https://x.com/",
            tiktok: "https://www.tiktok.com/@",
        };
        let { name, value } = e.target
        if (prefixMap[name]) {
            value = value.replace(prefixMap[name], "");
        }
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                digitalMedia: {
                    ...this.state.userInfo.digitalMedia,
                    [name]: value
                }
            }
        })

    }

    projectInfoChange = (e) => {
        const { name, value } = e.target
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                projectInfo: {
                    ...this.state.userInfo.projectInfo,
                    [name]: value
                }
            }

        })

    }
    handleCheckBox = (e) => {
        const { name, value, checked } = e.target
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                projectInfo: {
                    ...this.state.userInfo.projectInfo,
                    [name]: checked
                }
            }

        })
    }
    closeAdminUser = () => {
        this.setState({
            deleteImagePopup: false
        })
    }
    publicContactChange = (e) => {
        const { name, value } = e.target
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                publicContact: {
                    ...this.state.userInfo.publicContact,
                    [name]: name === 'website' ? value.replace('https://www.', '') : value
                }
            }

        })

    }

    postFestivalContactChange = (e) => {
        const { name, value } = e.target
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                postFestivalContact: {
                    ...this.state.userInfo.postFestivalContact,
                    [name]: name === 'website' ? value.replace('https://www.', '') : value
                }
            }

        })

    }

    secondPostFestivalContactChange = (e) => {
        const { name, value } = e.target
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                secondPostFestivalContact: {
                    ...this.state.userInfo.secondPostFestivalContact,
                    [name]: name === 'website' ? value.replace('https://www.', '') : value
                }
            }

        })
    }

    previewRecord = (e) => {
        e.preventDefault()
        var UpdatedData = this.state.userInfo;
        //  updateCreateFilm = {}
        const credits = this.state.userInfo.credits.map((credit) => {
            return {
                ...credit,
                creditType: credit.creditType.map((data) => {
                    const newDetails = { ...data.creditDetails };
                    if (newDetails.facebook) newDetails.facebook = PRE_FIX.facebook + newDetails.facebook.replace(PRE_FIX.facebook, '');
                    if (newDetails.bluesky) newDetails.bluesky = PRE_FIX.bluesky + newDetails.bluesky.replace(PRE_FIX.bluesky, '');
                    if (newDetails.instagram) newDetails.instagram = PRE_FIX.instagram + newDetails.instagram.replace(PRE_FIX.instagram, '');
                    if (newDetails.tiktok) newDetails.tiktok = PRE_FIX.tiktok + newDetails.tiktok.replace(PRE_FIX.tiktok, '');
                    if (newDetails.twitter) newDetails.twitter = PRE_FIX.twitter + newDetails.twitter.replace(PRE_FIX.twitter, '');
                    if (newDetails.youtube) {
                        const fullYoutubeUrl = newDetails.youtube.startsWith('https://') ? newDetails.youtube : PRE_FIX.youtube + newDetails.youtube;
                        newDetails.youtube = getEmbedUrl(fullYoutubeUrl);
                    }
                    return { ...data, creditDetails: newDetails };
                })
            };
        })
        let updateCreateFilm = {
            englishPhoneticProdununciation: this.state.userInfo.englishPhoneticProdununciation,
            credits: credits, 
            ...(isNewFrontierCategory(this.state.userInfo?.category, this.state.filmCategoryData, this.state.NewFrontierCategoryData) ? { filmProjectType: this.state.userInfo.filmProjectType } : {}),
            category: this.state.userInfo.category,
            article: this.state.userInfo.article,
            title: this.state.userInfo.title,
            pafType : this.state.userInfo.pafType,
            logline: this.state.userInfo.logline,
            countryOfOrigin: this.state.userInfo.countryOfOrigin,
            projectInfo: this.state.userInfo.projectInfo,
            digitalMedia: {
                ...this.state.userInfo.digitalMedia,
                youtubeOrVimeoTrailer: getEmbedUrl(this.state.userInfo.digitalMedia.youtubeOrVimeoTrailer ? (this.state.userInfo.digitalMedia.youtubeOrVimeoTrailer.startsWith('https://') ? this.state.userInfo.digitalMedia.youtubeOrVimeoTrailer : 'https://www.' + this.state.userInfo.digitalMedia.youtubeOrVimeoTrailer) : ''),
            },
            publicContact: this.state.userInfo.publicContact,
            postFestivalContact: this.state.userInfo.postFestivalContact,
            secondPostFestivalContact: this.state.userInfo.secondPostFestivalContact,
            projectId: this.state.userInfo.projectId,
            images: this.state.userInfo.images,
            // Contact Data
            mainPublicityContacts : UpdatedData.mainPublicityContacts,
            mainContacts : UpdatedData.mainContacts,
            techContact : UpdatedData.techContact,
            composer:this.state.userInfo.composer,
            userId:this.state.userInfo.userId,
            distributor:this.state.userInfo.distributor,
            editor:this.state.userInfo.editor,
            salesAgent:this.state.userInfo.salesAgent.length > 0 ? this.state.userInfo.salesAgent : [{
                address1: "",
                address2: "",
                city: "",
                company: "",
                country: "",
                email: "",
                firstName: "",
                lastName: "",
                middleName: "",
                distributionType:"",
                phoneNumber: "",
                state: "",
                title: "",
                type: "",
                zipCode: "",
                _id: (new Date().getTime() + Math.floor(Math.random() * 100)).toString(),
            }],
            cinematographer:this.state.userInfo.cinematographer,
            // Project Internal
            mediaId: UpdatedData.mediaId ? UpdatedData.mediaId : '',
            studentScreening: UpdatedData.studentScreening,
            freeCommunityScreening: UpdatedData.freeCommunityScreening,
            historyOfFilm: UpdatedData.historyOfFilm,
            adobeProductUse: UpdatedData.adobeProductUse,
            stockFootage: UpdatedData.stockFootage,
            cameras: UpdatedData.cameras,
            cameraPurchaseOrRent: UpdatedData.cameraPurchaseOrRent,
            cameraAnamorphicOrSpecialLense: UpdatedData.cameraAnamorphicOrSpecialLense,
            useCameraLence: UpdatedData.useCameraLence,
            influencedCamera: UpdatedData.influencedCamera,
            softwareUsedToEdit: UpdatedData.softwareUsedToEdit,
            useAdobeProducts: UpdatedData.useAdobeProducts,
            useHardware: UpdatedData.useHardware,
            useOtherTechnologyHardware: UpdatedData.useOtherTechnologyHardware,
            realTimes3DTools: UpdatedData.realTimes3DTools,
            useStockFootage: UpdatedData.useStockFootage,
            fundingPlatform: UpdatedData.fundingPlatform,
            sharingDistribution: UpdatedData.sharingDistribution,
            hybridDistribution: UpdatedData.hybridDistribution,
            useDropbox: UpdatedData.useDropbox,
            brieflyExplain: UpdatedData.brieflyExplain

        }
        let previewRecordFilm = this.apiserve.e(updateCreateFilm) 
        this.setState({ loaderFlag: true, btnDisabled: true })
        this.apiserve.sendevent("tempStorage|create", {tempData:previewRecordFilm});
    }

    //Year Call
    getYears = () => {
        var years = [];
        var startYear = new Date().getFullYear()+2;
        const year = 1900;
        for (var start = startYear; start >= year; start--) {
            years.push(start.toString());
        }
        return years;
    }

    year = this.getYears();

    handleCheck = (e) => {
        const { name, checked } = e.target;
        this.updateState({
            [name]: checked
        })
    }

    handleImageMeetArtist(e, CID, IID) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {

                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 5120) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 5MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadMeetArtists(file, CID, IID, event.target.result);
                    }, 1000)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            })
        }
    }

    imageUploadMeetArtists = (file, CID, IID, img) => {
        const imagePreloaderId = `imagePreloader_${CID}`
        const newState = { ...this.state }
        newState[imagePreloaderId] = true
        this.setState(newState)
        var fileSet = commonImage(file,false, '', img,'',STORAGE_PATHS.PAF.MEET_THE_ARTIST)
        fileSet.then((value) => {
                const newCredits = this.state.userInfo.credits.map(item => {
                    if (item._id === CID) {
                        const newCreditType = item.creditType.map(data1 => {
                            if (data1._id === IID) {
                                return {
                                    ...data1,
                                    creditDetails: {
                                        ...data1.creditDetails,
                                        ProfileUrl: value
                                    }
                                }
                            }
                            return data1
                        })
                        return { ...item, creditType: newCreditType }
                    }
                    return item
                })
                this.updateState({
                    [imagePreloaderId]: false,
                    userInfo: {
                        ...this.state.userInfo,
                        credits: newCredits
                    }
                })
            });
    };

    onEditorStateChangeDesc = (description, id) => {
        const newArtist = this.state.artist.map((dataList) => {
            if (dataList._id === id) {
                return { ...dataList, description: description };
            }
            return dataList;
        });

        this.updateState({ artist: newArtist });
    };

    handleChangeDate = (date, id) => {
        const newDateTime = this.state.dateTime.map(event => {
            if (event._id === id) {
                return { ...event, date: date }
            }
            return event
        });
        this.updateState({ dateTime: newDateTime })
    }

    handleTimeHours = (e, id) => {
        const newDateTime = this.state.dateTime.map(event => {
            if (event._id === id) {
                return { ...event, hours: e }
            }
            return event
        });
        this.updateState({ dateTime: newDateTime })
    }

    handleTimeMin = (e, id) => {
        const newDateTime = this.state.dateTime.map(event => {
            if (event._id === id) {
                return { ...event, minutes: e }
            }
            return event
        });
        this.updateState({ dateTime: newDateTime })
    }

    handleTimeStamps = (e, id) => {
        const newDateTime = this.state.dateTime.map(event => {
            if (event._id === id) {
                return { ...event, state: e }
            }
            return event
        });
        this.updateState({ dateTime: newDateTime })
    }

    onChangeScreeningType = (e, parentId) => {
        const { name, value } = e.target;
        const newDateTime = this.state.dateTime.map(screeening => {
            if (screeening._id === parentId) {
                return {
                    ...screeening,
                    [name]: { value: value, label: name },
                    locations: []
                }
            }
            return screeening
        });

        this.updateState({ dateTime: newDateTime })
    };

    handleChangeLocation = (value, parentId) => {
        const newDateTime = this.state.dateTime.map(screeening => {
            if (screeening._id === parentId) {
                return {
                    ...screeening,
                    emptyLocationError: (value !== null || value && value.length !== 0) ? '' : 'The location field is required.',
                    locations: value
                }
            }
            return screeening
        });

        this.updateState({ dateTime: newDateTime })
    }

    onChangeInpersonDropdown = (e, id) => {
        let all_inarray = [...this.state.inPersonArray];

        all_inarray.forEach(item => {
            item.isShow = false
            if (id === item?._id) {
                item.isShow = true
            }
        });
        this.updateState({
            InpersonDropdownVal: e.target.value
        })
    }

    makeOption = (data) => {
        return (
            { value: data, label: data }
        )
    }

    //Credit Push
    addCredit = (item) => {

        var newCredit = {
            _id: this.generateObjectId(),
            creditId: '',
            creditLabel: '',
            identifier: '',
            creditType: [{
                _id: this.generateObjectId(),
                firstName: '',
                middleName: '',
                lastName: '',
                creditDetails: { email: '' }
            }]
        }
        var oldCredit = this.state.userInfo.credits
        oldCredit.push(newCredit)
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                credits: oldCredit
            }

        })
        this.getCreditCount()
    }
    moveObjectAtIndex = (array, sourceIndex, destIndex) => {
        var placeholder = {};
        // remove the object from its initial position and
        // plant the placeholder object in its place to
        // keep the array length constant
        var objectToMove = array.splice(sourceIndex, 1, placeholder)[0];
        // place the object in the desired position
        array.splice(destIndex, 0, objectToMove);
        // take out the temporary object
        array.splice(array.indexOf(placeholder), 1);
        return array
    }

    submitFilm = (e) => {
        if (this.props.recordConflict) {
            this.setState({ showConflictModal: true });
            return;
        }
        const hasBioError = Object.values(this.state.bioErrors).some(v => v);
        if(this.validator.allValid() && !hasBioError){
            this.setState({ loaderFlag: true, btnDisabled: true })
            let castIndex =this.state.userInfo.credits.findIndex(element => element.identifier === 'principalcast')
            let creditLastIndex = this.state.userInfo.credits.length 
            let digitalMedia = {...this.state.userInfo.digitalMedia, facebook:this.state.userInfo.digitalMedia.facebook !== "" ? "https://www.facebook.com/"+this.state.userInfo.digitalMedia.facebook : this.state.userInfo.digitalMedia.facebook, officialWebsite:this.state.userInfo.digitalMedia.officialWebsite !== "" ? "https://www."+this.state.userInfo.digitalMedia.officialWebsite : '', youtubeOrVimeoTrailer:this.state.userInfo.digitalMedia.youtubeOrVimeoTrailer ? (this.state.userInfo.digitalMedia.youtubeOrVimeoTrailer.startsWith('https://') ? this.state.userInfo.digitalMedia.youtubeOrVimeoTrailer : "https://www."+this.state.userInfo.digitalMedia.youtubeOrVimeoTrailer) : '',instagram:this.state.userInfo.digitalMedia.instagram !== '' ? "https://www.instagram.com/"+ this.state.userInfo.digitalMedia.instagram : this.state.userInfo.digitalMedia.instagram,
                bluesky:this.state.userInfo.digitalMedia.bluesky !== '' ? "https://bsky.app/profile/"+ this.state.userInfo.digitalMedia.bluesky : this.state.userInfo.digitalMedia.bluesky,
                twitter:this.state.userInfo.digitalMedia.twitter !== '' ? "https://x.com/"+ this.state.userInfo.digitalMedia.twitter : this.state.userInfo.digitalMedia.twitter,
                tiktok:this.state.userInfo.digitalMedia.tiktok !== '' ? "https://www.tiktok.com/@"+ this.state.userInfo.digitalMedia.tiktok : this.state.userInfo.digitalMedia.tiktok,
            }
            const meetArtistIdentifier = this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? 'leadartist' : this.state.userInfo.credits[0].identifier;
            const credits = this.state.userInfo.credits.map((credit) => {
                if (credit.identifier !== meetArtistIdentifier) return credit;
                return {
                    ...credit,
                    creditType: credit.creditType.map((data) => {
                        const newDetails = { ...data.creditDetails };
                        if (newDetails.facebook) newDetails.facebook = PRE_FIX.facebook + newDetails.facebook.replace(PRE_FIX.facebook, '');
                        if (newDetails.bluesky) newDetails.bluesky = PRE_FIX.bluesky + newDetails.bluesky.replace(PRE_FIX.bluesky, '');
                        if (newDetails.instagram) newDetails.instagram = PRE_FIX.instagram + newDetails.instagram.replace(PRE_FIX.instagram, '');
                        if (newDetails.tiktok) newDetails.tiktok = PRE_FIX.tiktok + newDetails.tiktok.replace(PRE_FIX.tiktok, '');
                        if (newDetails.twitter) newDetails.twitter = PRE_FIX.twitter + newDetails.twitter.replace(PRE_FIX.twitter, '');
                        if (newDetails.youtube) newDetails.youtube = newDetails.youtube.startsWith('https://') ? newDetails.youtube : PRE_FIX.youtube + newDetails.youtube;
                        return { ...data, creditDetails: newDetails };
                    })
                };
            })
            let data = {
                pafType: this.state.userInfo.pafType,
                fileMakerId: this.state.userInfo.fileMakerId,
                englishPhoneticProdununciation: this.state.userInfo.englishPhoneticProdununciation,
                ...(isNewFrontierCategory(this.state.userInfo?.category, this.state.filmCategoryData, this.state.NewFrontierCategoryData) ? { filmProjectType: this.state.userInfo.filmProjectType } : {}),
                credits: credits,
                category: this.state.userInfo.category,
                article: this.state.userInfo.article,
                title: this.state.userInfo.title,
                logline: this.state.userInfo.logline,
                countryOfOrigin: this.state.userInfo.countryOfOrigin.length === 1 && this.state.userInfo.countryOfOrigin[0].country === "" ? [] : this.state.userInfo.countryOfOrigin,
                projectInfo: this.state.userInfo.projectInfo,
                digitalMedia: digitalMedia,
                publicContact: {...this.state.userInfo.publicContact, website: this.state.userInfo.publicContact.website !== "" ? "https://www." + this.state.userInfo.publicContact.website : ""},
                postFestivalContact: {...this.state.userInfo.postFestivalContact, website: this.state.userInfo.postFestivalContact.website !== "" ? "https://www." + this.state.userInfo.postFestivalContact.website : ""},
                secondPostFestivalContact: {...this.state.userInfo.secondPostFestivalContact, website: this.state.userInfo.secondPostFestivalContact.website !== "" ? "https://www." + this.state.userInfo.secondPostFestivalContact.website : ""},
                projectId: this.state.userInfo.projectId,
                images: this.state.userInfo.images
            }
            this.apiserve.sendevent("paf|project|updateFirstPage", data);
        } else {
            this.setState({
                messageModal: true,
            })
            this.validator.showMessages();
            this.forceUpdate();
        }
        // this.apiserve.success("Project Saved Successful.");
    }
    ClosemessageModal = () => {
        this.setState({
            messageModal: false,
        })
    }
    //Credit Remove
    removeCredit = (id) => {
        var filteredCredit = this.state.userInfo.credits.filter(_ => _._id !== id)
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                credits: filteredCredit
            }
        }, () => {
            this.getCreditCount()
        })
    }
    addInsideCredit = (item) => {
        let projectCredits
        if (this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER) {
            projectCredits = {
                'leadartist': 3,
                'keycollaborator': 2,
                principalcast : 5
            }
        } else {
            projectCredits = {
                director: 3,
                screenwriter: 2,
                principalcast :5
            }
        }
        if (item.creditId !== '') {
            var creditType = {
                _id: this.generateObjectId(),
                firstName: '',
                middleName: '',
                lastName: '',
                creditDetails: { email: '' }
            }
            this.state.userInfo.credits.forEach(element => {
                if (element._id === item._id) {
                    if (projectCredits[element.identifier] !== undefined) {
                        if (element.creditType.length < (projectCredits[element.identifier] + 1))
                            element.creditType.push(creditType)
                    } else {
                        element.creditType.push(creditType)
                    }
                }
            });

        }
        this.getCreditCount()
        this.updateState({})
    }

    removeInsideCredit = (parentId, childId) => {
        this.state.userInfo.credits.forEach(element => {
            if (element._id === parentId) {
                var filterInsideCredit = element.creditType.filter(_ => _._id !== childId);
                element.creditType = filterInsideCredit
            }
        });
        this.getCreditCount()

        this.updateState({});
    }
   
    onChangeCredit = (e, CID, IID) => {
        let newCredit = this.state.userInfo.credits
        newCredit.forEach(credit => {
            if (credit._id === CID) {
                credit.creditType.forEach(data => {
                    if (data._id === IID) {
                        const { name, value } = e.target
                        data[name] = value
                    }
                })
            }
        });

        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                credits: newCredit
            }

        });

    }

    dropChangeCreditLabel = (e, id, CID) => {
        let newCredit = this.state.userInfo.credits
        let { filmcreditLabels, userInfo, newFrontierCreditLabel } = this.state
        const { name, value } = e.target
        let checkCredit = newCredit.find(_ => _.creditId === value)
        if (!checkCredit) {

            newCredit.forEach(credit => {

                if (credit._id === id) {
                    credit[name] = value
                    credit.creditLabel = userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? newFrontierCreditLabel.find(_ => _._id === value).name : filmcreditLabels.find(_ => _._id === value).name
                    credit.identifier = userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? newFrontierCreditLabel.find(_ => _._id === value).identifier : filmcreditLabels.find(_ => _._id === value).identifier
                    credit.creditType = credit.identifier === "screenwriter" ? credit.creditType.length > 3 ? credit.creditType.slice(0, 3) : credit.creditType : credit.identifier === "director" && credit.creditType.length > 4 ? credit.creditType.slice(0, 4) : credit.identifier === "principalcast" && credit.creditType.length > 6 ? credit.creditType.slice(0, 6) : credit.creditType
                }
            });
        }
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                credits: newCredit
            }
        },() => {
            this.getCreditCount()
        });
    }

    onDragEnd = (result) => {
        if (!result.destination) return;
        const { destination, source, type } = result;

        if (type.startsWith('CREDIT_NAMES_')) {
            const credits = this.state.userInfo?.credits;
            if (!credits) return;
            const parentIdx = credits.findIndex(c => c._id.toString() === destination.droppableId);
            if (parentIdx === -1) return;
            const creditType = credits[parentIdx].creditType;
            creditType.splice(destination.index, 0, creditType.splice(source.index, 1)[0]);
            this.updateState({});
            return;
        }

        const oldIndex = source.index;
        const newIndex = destination.index;
        const credits = this.state.userInfo?.credits;
        if (credits) {
            credits.splice(newIndex, 0, credits.splice(oldIndex, 1)[0]);
        }
        this.setState({ isDraggable: true });
        this.updateState({});
    }


    deleteImagePopup = () => {

        if (this.state.sponsorLogoDetails) {
            this.updateState({
                sponsorLogo: '',
            })
        }
        if (this.state.awardSponsorLogoDetails) {
            this.updateState({
                awardSponsorLogo: ''
            })
        }
        if (this.state.userInfo.images.length) {
            this.state.userInfo.images.forEach(image => {
                if (image._id === this.state.deleteImageId) {
                    image.inSite = ''
                }
            });
        }
        const imagePreloaderId = `imagePreloader_${this.state.deleteImageId}`
        const newState = { ...this.state }
        if (this.state.deleteImageSubId !== '') {
            this.state.userInfo.credits.forEach(credit => {
                if (credit._id === this.state.deleteImageId) {
                    credit.creditType.forEach(data => {
                        if (data._id === this.state.deleteImageSubId) {

                            data.creditDetails.ProfileUrl = ''
                            newState[imagePreloaderId] = true
                            this.updateState(newState)
                        }
                    })
                }
            })
        }

        newState[imagePreloaderId] = false
        this.updateState({
            ...newState,
            deleteImagePopup: false,
            sponsorLogoDetails: false,
            awardSponsorLogoDetails: false,
            deleteImageId: '',

        })

    }

    setDeleteImagePopup = (id) => {
        this.setState({
            deleteImagePopup: true,
            deleteId: id
        })
    }


    deleteImage(id, IID, TYPE) {

        if (TYPE === 'MEET') {
            this.setState({
                deleteImagePopup: true,
                deleteImageId: id,
                deleteImageSubId: IID
            })
        } else {
            this.setState({
                deleteImagePopup: true,
                deleteImageId: id,
                deleteImageSubId: ''
            })
        }
    }

    deleteImageSponsor() {
        this.setState({
            deleteImagePopup: true,
            awardSponsorLogoDetails: false,
            sponsorLogoDetails: true,
        })
    }

    deleteImageAwardSponsorLogo() {
        this.setState({
            deleteImagePopup: true,
            awardSponsorLogoDetails: true,
            sponsorLogoDetails: false
        })
    }

    uploadVideoImage = (file, id, img) => {
        const imagePreloaderId = `imagePreloader_${id}`;
        const newState = { ...this.state, videoPreLoader: true };
        newState[imagePreloaderId] = true;
        this.setState(newState);
        var fileSet = commonImage(file,false, '', img, '', STORAGE_PATHS.PAF.IMAGES);
        fileSet.then((value) => {
            const newImages = this.state.userInfo.images.map(image => {
                if (image._id === id) {
                    return { ...image, inSite: value }
                }
                return image
            });
            this.updateState({
                videoPreLoader: false,
                [imagePreloaderId]: false,
                userInfo: {
                    ...this.state.userInfo,
                    images: newImages
                }
            })
        });
    }

    handleImage(e, id) {
        e.stopPropagation();
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file); reader.onloadend = (event) => {
            this.setState({
                file: file
            });
            if (
                (file && file.type === "image/png") ||
                (file && file.type === "image/jpg") ||
                (file && file.type === "image/jpeg")
            ) {
                const fileList = Math.round(file && file.size / 1024);
                if (fileList >= 10240) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: "Please upload a file smaller than 10MB"
                    });
                    return false;
                }
                if (file && (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg")) {
                    // this.setState({ isImage: true });
                    setTimeout(() => {
                        this.uploadVideoImage(file, id, event.target.result);
                    }, 0);
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: "Please Upload PNG/JPEG of max size of 5MB OR MP4 of max size 200MB"
                    });
                }
            } else {
                if (file.size > 200e6) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: "Please upload a video smaller than 200 MB"
                    });
                    return false;
                }

                if (file.type === "video/mp4") {
                    setTimeout(() => {
                        this.uploadVideoImage(file, id,event.target.result);
                    }, 0);
                    return false;
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: "Please Upload PNG/JPEG of max size of 5MB OR MP4 of max size 200MB"
                    });
                }
            }
        };
        const errorMsgPopup = () => {
            this.setState({
                errorPopup: false
            })
        }
    }

    insideOnchange = (e, id) => {
        const { name, value } = e.target
        const newImages = this.state.userInfo.images.map(inside => {
            if (inside._id === id) {
                return { ...inside, [name]: value }
            }
            return inside
        });

        this.updateState({
            userInfo: {
                ...this.state.userInfo,
                images: newImages
            }
        });
    }

    errorMsgPopup = () => {
        this.setState({
            errorPopup: false
        })
    }

    selectCountryOfOrigin = (e, id) => {
        let countries = this.state.userInfo.countryOfOrigin
        countries.forEach(country => { if (country.id === id) country.country = e.target.value });
        this.updateState({
            userInfo: {
                ...this.state.userInfo,
                countryOfOrigin: countries
            }
        })
    }

    addCountry = (e) => {
        let countries = this.state.userInfo.countryOfOrigin;
        var newAdded = {
            id: new Date().getTime().toString(),
            country: ''
        }
        countries.push(newAdded);
        this.updateState({
            userInfo: {
                ...this.state.userInfo,
                countryOfOrigin: countries
            }
        })
    }

    cancelFn = () => {
        this.props.history.push('/paf-projectlist');
    }

    removeCountry = (e, id) => {
        const countryTypes = this.state.userInfo.countryOfOrigin.filter(item => item.id != id)
        this.updateState({
            ...this.state,
            userInfo: {
                ...this.state.userInfo,
                countryOfOrigin: countryTypes
            }

        })
    }
    handleKeySlider = (e) => {
        if (e.keyCode === 9) { // Check if the pressed key is Tab (key code 9)
            e.preventDefault(); // Prevent the default tab focus behavior
        }
    }

    validLink = (link) => {
        let regex = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
        if(regex.test(link)){
            return link
        } else {
            return '/images/image-placeholder.png'
        }
    }

    imageOnError = (event) => {
        event.currentTarget.src = `/images/image-placeholder.png`;
    };

    render() {
        const year = this.getYears();
        var settings = {
            customPaging: function (i) {
                return (
                    <a>{i + 1}</a>
                );
            },
            dots: true,
            arrows: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        this.validator.purgeFields();

        // Project module 

        return (
            <>
                <form>
                    <div className="d_flex d_flex_align_baseline project_section">
                    {this.state.loaderFlag ?  <Loader /> : ''}
                        <div className="tab_col create_left_col create_left_postAcceptance">
                            <div className="d_flex fpg_media_id d_flex_align_center mb_5">
                                <div className="field_row horizontal_field paf_view_page ">
                                    <ul className="data_list ">
                                        <li className="d_flex">
                                            <label style={{ width: "50px" }}>Media ID: </label>  <span id="id_text" className="ml_10" > {this.state.userInfo.mediaId}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="field_row horizontal_field ml_10 ">
                                    <TextField
                                        type="text"
                                        name="fileMakerId" id="fileMakerId"
                                        label="Filemaker ID:"
                                        value={this.state.userInfo.fileMakerId}
                                        onChange={this.onInputChange}
                                    />
                                </div>
                            </div>
                            <div className="left_col">


                                <Slider {...settings} >

                                    {this.state.userInfo.images &&
                                        this.state.userInfo.images.map((item, index) => {
                                            const imagePreloaderState = `imagePreloader_${item._id}`
                                            return (
                                                <div>
                                                    <div className="media_image mb_0 absolute_loader">
                                                        {this.state[imagePreloaderState] ?
                                                            <Loader />
                                                            :
                                                            <img src={item.inSite ? this.apiserve.imageUrl + item.inSite : item.link ? this.validLink(item.link) : '/images/image-placeholder.png'} alt="image" onError={(e) => this.imageOnError(e)}/>
                                                        }
                                                        <span className="upload_message">Upload PNG/JPEG of max size of 10MB</span>

                                                        <UploadForm item={item} handleImage={(e) => this.handleImage(e, item._id)}
                                                            deleteImage={() => this.deleteImage(item?._id)} iconDelete={true} />
                                                    </div>
                                                    <div className="field_row">
                                                        <div className="field_input relative">
                                                            <input
                                                                type="text"
                                                                placeholder="https://cloudfront.aws.com/sdf2345"
                                                                name='link'
                                                                id={item._id}
                                                                value={item.link}
                                                                onChange={(e) => this.insideOnchange(e, item._id)}
                                                                onKeyDown={(e) => this.handleKeySlider(e)}
                                                            />
                                                            <span className="copy_box pointer_auto">
                                                                <CopyIcon />
                                                            </span>
                                                        </div>
                                                    </div>
                                                    {index === 0 ?
                                                        <span style={{ color: 'red' }}>{this.validator.message('image or link', item.link || item.inSite, 'urlValidation')}</span>
                                                        : ''
                                                    }
                                                </div>
                                            )
                                        })}
                                </Slider>

                                <div className="relative  static_pagination">

                                </div>
                            </div>
                            <div className="credit_section">
                                <div className="credit_header">
                                    <h5>Credits</h5>
                                </div>
                                <div className="create_credit_content">
                                <DragDropContext onDragEnd={this.onDragEnd}>
                                <Droppable droppableId="droppable" type="CREDIT_TITLE">
                                {(provided, snapshot) => (
                                    <ul {...provided.droppableProps} ref={provided.innerRef}>
                                        {this.state.userInfo?.credits?.map((item, index) => {
                                            return (
                                             <Draggable
                                                key={item._id}
                                                draggableId={`'${item._id}'`}
                                                index={index}
                                            >
                                                 {(provided, snapshot) => (
                                                     <li className="d_flex d_flex_align_center d_flex_align_start" 
                                                     ref={provided.innerRef}
                                                     {...provided.draggableProps}
                                                     {...provided.dragHandleProps}>
                                                     <span className="pointer d_flex dragger">
                                                         <DraggerIcon />
                                                     </span>
                                                     <div className="dopdown_add_remove d_flex d_flex_align_center">
                                                         <p className="action_wrap d_flex d_flex_align_center action_wrap d_flex_justify_end">
                                                             {index === 0 ?
                                                                 <span style={{ cursor: (this.state.creditCounter >= 24 || this.state.userInfo?.credits.filter(item => this.state.userInfo?.pafType === PAF_TYPES.INDIE_SERIES ? (item.identifier !== this.state.userInfo?.indieTopcredit?.identifier && item.identifier !== this.state.userInfo?.indieAdditionalTopCredit?.identifier) : (item.identifier !== 'director' && item.identifier !== 'screenwriter' && item.identifier !== 'principalcast')).length >= 10) ? 'not-allowed' : 'pointer' }} onClick={() => (this.state.creditCounter < 24 && this.state.userInfo?.credits.filter(item => item.identifier !== 'director' && item.identifier !== 'screenwriter' && item.identifier !== 'principalcast').length < 10) ? this.addCredit(item) : ""}>
                                                                     <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                 </span>
                                                                 :
                                                                 <>
                                                                     <span className="pointer" onClick={() => this.removeCredit(item._id)}>
                                                                         <FpgMinusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                     </span>
                                                                     <span style={{ cursor: (this.state.creditCounter >= 24 || this.state.userInfo?.credits.filter(item => this.state.userInfo?.pafType === PAF_TYPES.INDIE_SERIES ? (item.identifier !== this.state.userInfo?.indieTopcredit?.identifier && item.identifier !== this.state.userInfo?.indieAdditionalTopCredit?.identifier) : (item.identifier !== 'director' && item.identifier !== 'screenwriter' && item.identifier !== 'principalcast')).length >= 10) ? 'not-allowed' : 'pointer' }} onClick={() => (this.state.creditCounter < 24 && this.state.userInfo?.credits.filter(item => item.identifier !== 'director' && item.identifier !== 'screenwriter' && item.identifier !== 'principalcast').length < 10) ? this.addCredit(item) : ""} >
                                                                         <FpgPlusIcon className="pointer" width="20" height="20" color="#7758B3" stroke="#fff" />
                                                                     </span>
                                                                 </>
                                                             }
                                                         </p>
                                                         <div className="field_row mb_0">
                                                            {this.state.projectUserId ?
                                                             <DropdownMaster
                                                                 name="creditId"
                                                                 options={this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? this.state.newFrontierCreditLabel : this.state.filmcreditLabels}
                                                                 onChange={(e) => this.dropChangeCreditLabel(e, item._id, item.creditId)}
                                                                 value={item?.creditId}
                                                                 fpgerror={this.validator.message('creditLabel', item.creditId, 'required')}
                                                             />
                                                            :
                                                            <DropdownMaster
                                                            name="creditId"
                                                            options={this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? this.state.newFrontierCreditLabel : this.state.filmcreditLabels}
                                                            onChange={(e) => this.dropChangeCreditLabel(e, item._id, item)}
                                                            fpgerror={this.validator.message('creditLabel', item.creditId, 'required')}
                                                        />
                                                            }
 
                                                         </div>
 
                                                     </div>
                                                     <div>
                                                         <Droppable droppableId={item._id.toString()} type={`CREDIT_NAMES_${item._id}`} direction="vertical">
                                                             {(providedInner) => (
                                                                 <div ref={providedInner.innerRef} {...providedInner.droppableProps}>
                                                                     {item && item?.creditType?.map((insideCredit, indsideIndex) => {
                                                                         let projectCreditsLimit
                                                                         let limit
                                                                         if (this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER) {
                                                                             limit = item.identifier.toLowerCase() === 'leadartist' ? 3 : item.identifier.toLowerCase() === 'keycollaborator' ? 2 : item.identifier.toLowerCase() === 'cast' ? 5 : ''
                                                                             // limit = item.identifier === 'Director' ? 3 : item.identifier === "Screenwriter" ? 2 : item.identifier === 'Producer' ? 5 : item.identifier === 'Cast' ? 5 : ''
                                                                             projectCreditsLimit = {
                                                                                 LeadArtist: 3,
                                                                                 KeyCollaborator: 2,
                                                                                 Cast: 5
                                                                             }

                                                                         } else {
                                                                             // item.identifier === 'producer' ? 5 :
                                                                             limit = item.identifier === 'director' ? 3 : item.identifier === "screenwriter" ? 2 :  item.identifier === 'cast' ? 5 : ''
                                                                             projectCreditsLimit = {
                                                                                 Director: 3,
                                                                                 Screenwriter: 2,
                                                                                 // Producer: 5,
                                                                                 Cast: 5
                                                                             }
                                                                         }
                                                                         return (
                                                                             <Draggable key={insideCredit._id} draggableId={insideCredit._id.toString()} index={indsideIndex}>
                                                                                 {(providedName) => (
                                                                                     <div ref={providedName.innerRef} {...providedName.draggableProps} className="textfield_add_remove d_flex d_flex_align_center text_field_width">
                                                                                         <span className="pointer d_flex dragger mt_0 mr_5" {...providedName.dragHandleProps}>
                                                                                             <DraggerIcon />
                                                                                         </span>

                                                                                         <div className="field_row mb_0">
                                                                                             <TextField type="text" name="firstName" id="first" value={insideCredit.firstName} onChange={(e) => this.onChangeCredit(e, item._id, insideCredit._id)} maxLength={100} />
                                                                                         </div>
                                                                                         <div className="field_row mb_0 mr_5 ml_5">
                                                                                             <TextField type="text" name="middleName" id="middle" value={insideCredit.middleName} onChange={(e) => this.onChangeCredit(e, item._id, insideCredit._id)} />
                                                                                         </div>
                                                                                         <div className="field_row mb_0">
                                                                                             <TextField type="text" name="lastName" id="last" value={insideCredit.lastName} onChange={(e) => this.onChangeCredit(e, item._id, insideCredit._id)} maxLength={100} />
                                                                                         </div>

                                                                                         <p className="action_wrap aaaa d_flex d_flex_align_center action_wrap ">
                                                                                             {indsideIndex === 0 ?
                                                                                                 <span style={{cursor: ((!['director','screenwriter','principalcast'].includes(item.identifier) && this.state.creditCounter >= 24) || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' && item.creditType.length >= 3)) ? 'not-allowed' : 'pointer'}} onClick={() => (!['director','screenwriter','principalcast'].includes(item.identifier) && this.state.creditCounter >= 24) ? '' : this.addInsideCredit(item)}>
                                                                                                     <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                                 </span> :
                                                                                                 <>
                                                                                                     {limit === indsideIndex ? '' : <span style={{cursor: ((!['director','screenwriter','principalcast'].includes(item.identifier) && this.state.creditCounter >= 24) || !item.hasOwnProperty('identifier') || (item.identifier === 'director' ? item.creditType.length >= 4 : item.identifier === 'screenwriter' && item.creditType.length >= 3)) ? 'not-allowed' : 'pointer'}} onClick={() => (!['director','screenwriter','principalcast'].includes(item.identifier) && this.state.creditCounter >= 24) ? '': this.addInsideCredit(item)}>
                                                                                                         <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                                     </span>}

                                                                                                     <span className="pointer" onClick={() => this.removeInsideCredit(item._id, insideCredit._id)}>
                                                                                                         <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                                     </span>
                                                                                                 </>
                                                                                             }
                                                                                         </p>


                                                                                     </div>
                                                                                 )}
                                                                             </Draggable>
                                                                         )
                                                                     })}
                                                                     {providedInner.placeholder}
                                                                 </div>
                                                             )}
                                                         </Droppable>
                                                     </div>
                                                 </li>
                                                 )}
                                                 
                                            </Draggable>
                                              
                                            )
                                        }
                                        )}
                                        {provided.placeholder}
                                    </ul>
                                )}
                                </Droppable>
                                </DragDropContext>
                                    
                                </div>
                            </div>
                            <div className="credit_section artist_section">
                                <div className="credit_header">
                                    <h5>{this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? 'Official Social Links' : 'Digital Media'}</h5>
                                </div>
                                <div className="artist_content no_bg">
                                    <div className="field_row horizontal_field">
                                        <TextField label="Official Website" placeholder="" type="text" name="officialWebsite" value={this.state.userInfo.digitalMedia?.officialWebsite} onChange={(e) => this.DigitalChange(e)} prefix={true}/>
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField label="YouTube or Vimeo Trailer" placeholder="" type="text" name="youtubeOrVimeoTrailer" value={this.state.userInfo.digitalMedia.youtubeOrVimeoTrailer} onChange={(e) => this.DigitalChange(e)} prefix={true}/>
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField label="Instagram" placeholder="" type="text" name="instagram" value={this.state.userInfo.digitalMedia.instagram} onChange={(e) => this.DigitalChange(e)} prefix={true} prefixWidth="https://www.instagram.com/" />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField label="Facebook" placeholder="" type="text" name="facebook" value={this.state.userInfo.digitalMedia.facebook} onChange={(e) => this.DigitalChange(e)} prefix={true} prefixWidth="https://www.facebook.com/" />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField label="TikTok" placeholder="" type="text" name="tiktok" value={this.state.userInfo.digitalMedia.tiktok} onChange={(e) => this.DigitalChange(e)} prefix={true} prefixWidth="https://www.tiktok.com/@" />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField label='X (Formerly "Twitter")' placeholder="" type="text" name="twitter" value={this.state.userInfo.digitalMedia.twitter} onChange={(e) => this.DigitalChange(e)} prefix={true} prefixWidth="https://x.com/" />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField label="Bluesky" placeholder="" type="text" name="bluesky" value={this.state.userInfo.digitalMedia.bluesky} onChange={(e) => this.DigitalChange(e)} prefix={true} prefixWidth="https://bsky.app/profile/" />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField label="Hashtag" placeholder="" type="text" name="hastag" value={this.state.userInfo.digitalMedia.hastag} onChange={(e) => this.DigitalChange(e)} />
                                    </div>
                                </div>
                            </div>
                            <div className="credit_section artist_section">
                                <div className="credit_header">
                                    <h5>Meet The Artist</h5>
                                    <span></span>
                                </div>
                                {this.state.userInfo.credits.map((item, i) => {
                                    return (<>
                                        {item.identifier === (this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? 'leadartist' : this.state.userInfo.credits[0].identifier) ? item.creditType.map((data, i) => {
                                            const imagePreloaderState = `imagePreloader_${item._id}`
                                            return (
                                                <>
                                                    <div className="artist_content d_flex">
                                                        <div className="artist_content_side">
                                                            <div className="d_flex inner_artist">
                                                                <div className="artist_user absolute_loader">
                                                                    <div className='artist_img'>
                                                                        {this.state[imagePreloaderState] ?
                                                                            <Loader />
                                                                            :
                                                                            <img src={data.creditDetails.ProfileUrl ? this.apiserve.imageUrl + data.creditDetails.ProfileUrl : '/images/user.png'} alt="image" />
                                                                        }
                                                                        <UploadForm item={item} handleImage={(e) => this.handleImageMeetArtist(e, item._id, data._id)} iconDelete={data.creditDetails.ProfileUrl ? true : false} deleteImage={() => this.deleteImage(item._id, data._id, 'MEET')} />
                                                                    </div>
                                                                    <label>Max size 5MB</label>
                                                                </div>
                                                                <div className="artist_data">
                                                                    <div className="artist_data_top d_flex">
                                                                        <div className="field_row">
                                                                            <TextField type="text" name="firstName" id="firstName" value={data.firstName} onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)}
                                                                            maxLength={100} />
                                                                        </div>
                                                                        <div className="field_row artist_middleName_m ">
                                                                            <TextField type="text" name="middleName" id="middleName" value={data.middleName} onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)}
                                                                            />
                                                                        </div>
                                                                        <div className="field_row">
                                                                            <TextField type="text" name="lastName" id="lastName" value={data.lastName} onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)}
                                                                            maxLength={100} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="field_row">
                                                                        <Textarea width='100%' value={data.creditDetails?.bio} name="bio" onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)} />
                                                                        <span>{data.creditDetails?.bio?.split(/\s+/)?.filter(_ => _ !== '').length > 0 ? data.creditDetails?.bio?.split(/\s+/)?.filter(_ => _ !== '').length : '0'}/50</span>
                                                                        {(data.creditDetails?.bio?.split(/\s+/)?.filter(_ => _ !== '').length ?? 0) > 50 && <span style={{ color: 'red' }} className='d_block w_100 error'>The Bio must be a maximum of 50 words.</span>}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="field_row horizontal_field">
                                                                <TextField label="Instagram" placeholder="" type="text" name="instagram" id="instagram" value={data.creditDetails?.instagram} onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)} prefix={true} prefixWidth={PRE_FIX.instagram} />
                                                            </div>
                                                            <div className="field_row horizontal_field">
                                                                <TextField label='TikTok' placeholder="" type="text" name="tiktok" id="tiktok" value={data.creditDetails?.tiktok} onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)} prefix={true} prefixWidth={PRE_FIX.tiktok} />
                                                            </div>
                                                            <div className="field_row horizontal_field">
                                                                <TextField label='Facebook' placeholder="" type="text" name="facebook" id="facebook" value={data.creditDetails?.facebook} onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)} prefix={true} prefixWidth={PRE_FIX.facebook}  />
                                                            </div>
                                                            <div className="field_row horizontal_field">
                                                                <TextField label='X (Formerly "Twitter")' placeholder="" type="text" name="twitter" id="twitter" value={data.creditDetails?.twitter} onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)} prefix={true} prefixWidth={PRE_FIX.twitter} />
                                                            </div>
                                                            <div className="field_row horizontal_field">
                                                                <TextField label='Bluesky' placeholder="" type="text" name="bluesky" id="bluesky" value={data.creditDetails?.bluesky} onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)} prefix={true} prefixWidth={PRE_FIX.bluesky}  />
                                                            </div>
                                                            <div className="field_row horizontal_field">
                                                                <TextField label="YouTube or Vimeo" placeholder="" type="text" name="youtube" id="youtube" value={data.creditDetails?.youtube} onChange={(e) => this.onInputChangeMeet(e, item._id, data._id)} prefix={true} />
                                                            </div>
                                                            <div className="field_row horizontal_field">
                                                                {/* Insert EMBED source link of the YT video */}
                                                                <div className="field_row_inner">
                                                                    <label className="mb_0"></label>
                                                                    <div className="field_input">
                                                                        <div className="video_wrap">
                                                                            <iframe src={getEmbedUrl(data.creditDetails?.youtube ? (data.creditDetails.youtube.startsWith('https://') ? data.creditDetails.youtube : 'https://www.' + data.creditDetails.youtube) : '')}> </iframe>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                        <div className="artist_action">
                                                            <p className="action_wrap d_flex d_flex_align_center action_wrap ">
                                                                {i === 0 ? (
                                                                    <span className="pointer" onClick={() => this.addInsideCredit(item, i)}>
                                                                        <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                    </span>
                                                                )
                                                                    :
                                                                    i >= 3 ? <span className="pointer" onClick={() => this.removeInsideCredit(item._id, data._id)}>
                                                                        <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                    </span>
                                                                        : (
                                                                            <>
                                                                                <span className="pointer" onClick={() => this.removeInsideCredit(item._id, data._id)}>
                                                                                    <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                </span>
                                                                                <span className="pointer" onClick={() => this.addInsideCredit(item, i)}>
                                                                                    <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" />
                                                                                </span>
                                                                            </>
                                                                        )
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }) : null}
                                    </>)
                                })}
                            </div>
                        </div>
                        <div className="tab_col create_feature_col create_feature_postAcceptance">
                            <div className="paf_screening_info paf_screening_form">
                                <h2 className="paf_screening_info_title">Screening/Project Info</h2>
                                <div className="d_flex d_flex_justify_end w_100 info_first_row screening_info_flex_start">
                                    <div className="field_row horizontal_field ">
                                    </div>
                                    <div className="field_row horizontal_field ">
                                        <Dropdown label="PAF Type " options={this.state.pafType} name='pafType' value={this.state.userInfo.pafType} disable={true} onChange={this.screeningChange} DefaultOption={'Select From Below'} />
                                    </div>
                                    <div className="field_row horizontal_field ">
                                        <DropdownMaster label="Category" options={this.state.userInfo.pafType === PAF_TYPES.NEW_FRONTIER ? this.state.NewFrontierCategoryData : this.state.filmCategoryData} name='category' value={this.state.userInfo.category} onChange={this.screeningChange} defaultValue={'Select From Below'} />
                                    </div>
                                </div>
                                {isNewFrontierCategory(this.state.userInfo?.category, this.state.filmCategoryData, this.state.NewFrontierCategoryData) && (
                                <div className="d_flex d_flex_justify_end w_100 info_first_row screening_info_flex_start">
                                    <div className="field_row horizontal_field ">
                                        <Dropdown label="Film / Project Type" DefaultOption={'Select From Below'} options={this.state.pafProjectType} name='filmProjectType' value={this.state.userInfo.filmProjectType} onChange={this.screeningChange} defaultValue={'Select From Below'} />
                                    </div>
                                </div>
                                )}
                                <div className="d_flex w_100 info_first_row d_flex_justify_end screening_info_flex_start">
                                    <div className="field_row horizontal_field">
                                        <TextField label="Article" name='article' value={this.state.userInfo.article} onChange={this.screeningChange} />
                                    </div>
                                    <div className="field_row horizontal_field ">
                                        <TextField label="Title" name='title' value={this.state.userInfo.title} onChange={this.screeningChange} />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField label="English Phonentic Pronunciation" name='englishPhoneticProdununciation' value={this.state.userInfo.englishPhoneticProdununciation} onChange={this.screeningChange}
                                        />
                                    </div>
                                </div>
                                <div className="w_100 yesno_dropdown">
                                    <div className="field_row horizontal_field ">
                                        <CheckBox type="checkbox" onChange={this.handleCheckBox} name={'requiredDCPAndProResFile'} label={'I understand and agree that if the Closed Caption file is faulty in any way, Sundance Institute may elect to use the Open Caption version for all in- person public screenings.'} value={this.state.userInfo.projectInfo.requiredDCPAndProResFile} checked={this.state.userInfo.projectInfo.requiredDCPAndProResFile} id={'requiredDCPAndProResFile'} />
                                    </div>
                                </div>
                                <div className="w_100 yesno_dropdown">
                                    <div className="field_row horizontal_field ">
                                        <CheckBox type="checkbox" onChange={this.handleCheckBox} name={'requiredDCP'} label={'I understand that an Open Caption version of our DCP is required. Open Captions show spoken English and audio description text on screen with the movie for Deaf and hard of hearing viewers at in-person screenings. Non-English language projects are required to provide an SDH ("Subtitles for the deaf and hard of hearing") version to be used for Open Caption screenings.'} value={this.state.userInfo.projectInfo.requiredDCP} checked={this.state.userInfo.projectInfo.requiredDCP} id={'requiredDCP'} />
                                    </div>
                                </div>
                                <div className="w_100 yesno_dropdown">
                                    <div className="field_row horizontal_field ">
                                        <Dropdown label="Will your DCP or ProRes include an Audio Description  soundtrack for Blind and low vision viewers?" options={["Yes, Closed Captioning", "Yes, Audio Descriptive Services","Yes, Both","Not Available"]} name='captionAudioInDCP' DefaultOption={'Select From Below'} value={this.state.userInfo.projectInfo.captionAudioInDCP} onChange={this.projectInfoChange} />
                                    </div>
                                </div>
                                <div className="w_100 yesno_dropdown">
                                    <div className="field_row horizontal_field ">
                                        <Dropdown label="Does your project include stroboscopic images or extensive light flickering that lasts longer than 5 seconds?" options={["Yes", "No"]} name='includeStroboscopicImg' DefaultOption={'Select From Below'} value={this.state.userInfo.projectInfo.includeStroboscopicImg} onChange={this.projectInfoChange} />
                                    </div>
                                </div>
                                <div className="timecode_field">
                                    <div className="field_row horizontal_field">
                                        <TextField label="If yes, provide timecode(s) where it occurs in project:" name='timecodeOccursInProject' placeholder="Timecode" value={this.state.userInfo.projectInfo.timecodeOccursInProject} onChange={this.projectInfoChange} />
                                    </div>
                                </div>
                                <div className="w_100 yesno_dropdown">
                                    <div className="field_row horizontal_field ">
                                        <div className="field_row_inner">
                                            <label>Sundance Institute is collecting data on whether Artificial Intelligence (AI) is being utilized in the filmmaking process. This information is for internal data collection purposes only. Your answers have no impact on whether, when, or where your film is screened.</label>
                                        </div>
                                    </div>
                                    <div className="field_row horizontal_field ">
                                        <Dropdown label="Did you use AI in any aspect of your project?" options={["Yes", "No"]} name='aiAspect' DefaultOption={'Select From Below'} value={this.state.userInfo.projectInfo.aiAspect} onChange={this.projectInfoChange} />
                                    </div>
                                    <div className="field_row horizontal_field">
                                        <TextField label="If yes, please share what tools were used and how they were used in the making of the project." name='aiAspectOther' value={this.state.userInfo.projectInfo.aiAspectOther} onChange={this.projectInfoChange} />
                                    </div>
                                </div>
                                <div className="d_flex border_btm_1 pb_10 mt_10 d_flex_justify_spacebt">
                                    <div className="paf_screening_col_left">
                                        <div className="field_row">
                                            <div className="field_row_inner">
                                                <label>Logline</label>
                                            </div>
                                        </div>
                                        <div className="form_group_textarea  mb_15">
                                            <Textarea width='434px' height='168px' value={this.state.userInfo.logline} name='logline' onChange={this.screeningChange} />
                                            <span>{this.state.loglineValidation ? 'More than 50 Words is not allowed.' : ""}</span>
                                            <p className='text_right mr_10'> {this.state.LoglineLength}/{this.state.userInfo.pafType ===PAF_TYPES.NARRATIVE_SHORTS  ? '40' : '50'}</p>
                                        </div>
                                        <div className="field_280">
                                            <div className="field_row horizontal_field">
                                                <Dropdown label="Year Finished" options={year} name='yearFinished' value={this.state.userInfo.projectInfo.yearFinished} onChange={(e) => this.projectInfoChange(e)} DefaultOption={'Select Year'} />
                                            </div>
                                        </div>
                                        <div className="add_remove_dropdown d_flex">
                                            <div className="field_row mr_15">
                                                <label>Country of Origin</label>
                                            </div>
                                            <div>
                                                {
                                                    this.state.userInfo.countryOfOrigin.map((item, i) => {
                                                        return (
                                                            <div className="d_flex">
                                                                <Dropdown label="" options={this.state.countryType} name='countryOfOrigin' value={item.country} onChange={(e) => this.selectCountryOfOrigin(e, item.id)} DefaultOption={'Select Country'} />
                                                                <div className="d_flex d_flex_justify_spacebt action_wrapper">
                                                                    {i === 0 ?
                                                                        <>
                                                                            <span style={{ cursor: this.state.userInfo.countryOfOrigin.length > 7 ? 'not-allowed' : 'pointer' }} className="pointer mr_5" onClick={(e) => this.state.userInfo.countryOfOrigin.length < 8 ? this.addCountry(e) : ''}> <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /></span>
                                                                        </>
                                                                        :
                                                                        <>
                                                                            {i >= 7 ? '' : <span style={{ cursor: this.state.userInfo.countryOfOrigin.length > 7 ? 'not-allowed' : 'pointer' }} className="pointer mr_5" onClick={(e) => this.state.userInfo.countryOfOrigin.length < 8 ? this.addCountry(e) : ''}> <FpgPlusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /></span>}
                                                                            <span className="pointer" onClick={(e) => this.removeCountry(e, item.id)}> <FpgMinusIcon className="pointer" width="20" height="20" color="#4F4F4F" stroke="#fff" /></span> </>}
                                                                </div>
                                                            </div>)
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="d_flex run_time_row">
                                            <div className="field_row horizontal_field">
                                                <TextField label="Run Time " name='runTime' value={this.state.userInfo.projectInfo.runTime} onChange={this.projectInfoChange} />
                                            </div>
                                            <div className="field_row horizontal_field ml_10 final_run_time">
                                                <Dropdown label="FINAL RUN TIME?" options={['Yes', 'No']} name='finalRunTime' value={this.state.userInfo.projectInfo.finalRunTime} onChange={this.projectInfoChange} DefaultOption={'Select From Below'} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="paf_screening_col_right">
                                        <div className="field_row horizontal_field">
                                            <TextField label="Primary Language" name='language' value={this.state.userInfo.projectInfo.language} onChange={this.projectInfoChange} />
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <Dropdown label="Subtitles for Non-English language?" options={['Yes', 'No','Some - Mixed Language']} name='subtitles' value={this.state.userInfo.projectInfo.subtitles} onChange={this.projectInfoChange} DefaultOption={'Select From Below'} />
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <Dropdown label="Premiere Status" options={['World Premiere', 'International Premiere', 'North American Premiere', 'U.S. Premiere', 'None']} name='premiereStatus' value={this.state.userInfo.projectInfo.premiereStatus} onChange={this.projectInfoChange} DefaultOption={'Select From Below'} />
                                        </div>
                                        <div className="field_row horizontal_field">
                                            <Dropdown label="Color" options={['Color', 'Black & White', 'Color & Black & White']} name='color' value={this.state.userInfo.projectInfo.color} onChange={this.projectInfoChange} DefaultOption={'Select From Below'} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="paf_screening_info mt_25 w_100 border_btm_1 pb_25">
                                <h2 className="paf_screening_info_title mb_10">Film Team - Public Contact Information </h2>
                                <div className="mb_10">
                                    <p className="paf_screening_info_subtitle uppercase mb_15">Public Contact (During Festival)</p>
                                    <div className="pub_contacts">
                                        <div className="d_flex pub_contacts_firstRow">
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="First Name" name='firstName' value={this.state.userInfo.publicContact.firstName} onChange={this.publicContactChange} maxLength={100} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Middle Name" name='middleName' value={this.state.userInfo.publicContact.middleName} onChange={this.publicContactChange} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Last Name" name='lastName' value={this.state.userInfo.publicContact.lastName} onChange={this.publicContactChange} maxLength={100} />
                                            </div>
                                        </div>
                                        <div className="d_flex pub_contacts_Row">
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Company" name='company' value={this.state.userInfo.publicContact.company} onChange={this.publicContactChange} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Public Email" name='publicEmail' value={this.state.userInfo.publicContact.publicEmail} onChange={this.publicContactChange} />
                                            </div>
                                        </div>
                                        <div className="d_flex pub_contacts_Row">
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Website" name='website' value={this.state.userInfo.publicContact.website} onChange={this.publicContactChange} prefix={true} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10 team_phone">
                                                <TextField label="Phone" name='phoneNumber' value={this.state.userInfo.publicContact.phoneNumber} onChange={this.publicContactChange} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10 team_phone_type">
                                                <Dropdown label="Phone Type" options={['Office', 'Mobile', 'Other']} name='type' value={this.state.userInfo.publicContact.type} onChange={this.publicContactChange} DefaultOption={'Select From Below'} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb_10">
                                    <p className="paf_screening_info_subtitle uppercase mb_15">POST FESTIVAL CONTACT (AFTER FESTIVAL)</p>
                                    <div className="pub_contacts">
                                        <div className="d_flex pub_contacts_firstRow">
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="First Name" name='firstName' value={this.state.userInfo.postFestivalContact.firstName} onChange={this.postFestivalContactChange} maxLength={100} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Middle Name" name='middleName' value={this.state.userInfo.postFestivalContact.middleName} onChange={this.postFestivalContactChange} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Last Name" name='lastName' value={this.state.userInfo.postFestivalContact.lastName} onChange={this.postFestivalContactChange} maxLength={100} />
                                            </div>
                                        </div>
                                        <div className="d_flex pub_contacts_Row">
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Company" name='company' value={this.state.userInfo.postFestivalContact.company} onChange={this.postFestivalContactChange} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Public Email" name='publicEmail' value={this.state.userInfo.postFestivalContact.publicEmail} onChange={this.postFestivalContactChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d_flex pub_contacts_Row">
                                        <div className="field_row horizontal_field mr_10">
                                            <TextField label="Website" name='website' value={this.state.userInfo.postFestivalContact.website} onChange={this.postFestivalContactChange} prefix={true} />
                                        </div>
                                        <div className="field_row horizontal_field mr_10 team_phone">
                                            <TextField label="Phone" name='phoneNumber' value={this.state.userInfo.postFestivalContact.phoneNumber} onChange={this.postFestivalContactChange} />
                                        </div>
                                        <div className="field_row horizontal_field mr_10 team_phone_type">
                                            <Dropdown label="Phone Type" options={['Office', 'Mobile', 'Work']} name='type' value={this.state.userInfo.postFestivalContact.type} onChange={this.postFestivalContactChange} DefaultOption={'Select From Below'} />
                                        </div>
                                    </div>
                                </div>
                                <div className="mb_10">
                                    <p className="paf_screening_info_subtitle uppercase mb_15">SECOND POST FESTIVAL CONTACT (AFTER FESTIVAL)</p>
                                    <div className="pub_contacts">
                                        <div className="d_flex pub_contacts_firstRow">
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="First Name" name='firstName' value={this.state.userInfo.secondPostFestivalContact.firstName} onChange={this.secondPostFestivalContactChange} maxLength={100} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Middle Name" name='middleName' value={this.state.userInfo.secondPostFestivalContact.middleName} onChange={this.secondPostFestivalContactChange} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Last Name" name='lastName' value={this.state.userInfo.secondPostFestivalContact.lastName} onChange={this.secondPostFestivalContactChange} maxLength={100} />
                                            </div>
                                        </div>
                                        <div className="d_flex pub_contacts_Row">
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Company" name='company' value={this.state.userInfo.secondPostFestivalContact.company} onChange={this.secondPostFestivalContactChange} />
                                            </div>
                                            <div className="field_row horizontal_field mr_10">
                                                <TextField label="Public Email" name='publicEmail' value={this.state.userInfo.secondPostFestivalContact.publicEmail} onChange={this.secondPostFestivalContactChange} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d_flex pub_contacts_Row">
                                        <div className="field_row horizontal_field mr_10">
                                            <TextField label="Website" name='website' value={this.state.userInfo.secondPostFestivalContact.website} onChange={this.secondPostFestivalContactChange} prefix={true} />
                                        </div>
                                        <div className="field_row horizontal_field mr_10 team_phone">
                                            <TextField label="Phone" name='phoneNumber' value={this.state.userInfo.secondPostFestivalContact.phoneNumber} onChange={this.secondPostFestivalContactChange} />
                                        </div>
                                        <div className="field_row horizontal_field mr_10 team_phone_type">
                                            <Dropdown label="Phone Type" options={['Office', 'Mobile', 'Work']} name='type' value={this.state.userInfo.secondPostFestivalContact.type} onChange={this.secondPostFestivalContactChange} DefaultOption={'Select From Below'} />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="text_center field_row w_100 buttons_outer">
                        <button className="uppercase" type='button' onClick={() => this.cancelFn()}>CANCEL</button>
                        {/* {this.state.filmId && */}
                        <button className="uppercase prev_btn" type='button' onClick={(e) => this.previewRecord(e)}  disabled={this.state.btnDisabled}>PREviEW</button>
                        {/* } */}
                        <button className={`uppercase ${ !(this.state.btnDisabled || (this.state.projectUserId ? !this.state.isProjectinfoEdited : false)) ? 'active' : '' }`} type='button' onClick={(e) => this.submitFilm(e)}  disabled={this.state.btnDisabled || (this.state.projectUserId ? !this.state.isProjectinfoEdited : false)}>SAVE</button>
                    </div>

                </form>
                {this.state.messageModal &&
                    <ModalMessage messageModal={this.state.messageModal} withoutEmail={"Few or all of the required fields are missing. Please scroll up and check to add and confirm and resubmit"} ClosemessageModal={this.ClosemessageModal} />
                }
                {this.state.deleteImagePopup ? (
                    <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteImagePopup}
                    />
                ) : (
                    ""
                )}
                {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''    
                }
            <ConflictSaveModal
                isVisible={this.state.showConflictModal}
                conflict={this.props.recordConflict}
                onClose={() => this.setState({ showConflictModal: false })}
            />
            </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Projectinfo)

